import React from 'react';
import ColorStop from './ColorStop';
import PropTypes from 'prop-types';

class ColorStopsHolder extends React.Component {
  render() {
    const { width, stops, ...rest } = this.props;
    const style = {
      width,
      height: 17,
      position: 'relative',
    };
    return (
      <div className="csh" style={style}>
        {stops.map(stop => (
          <ColorStop key={stop.id} stop={stop} {...rest} />
        ))}
      </div>
    );
  }
}

ColorStopsHolder.propTypes = {
  width: PropTypes.number.isRequired,
  stops: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      pos: PropTypes.number.isRequired,
      isActive: PropTypes.bool.isRequired,
      pointX: PropTypes.number,
    }).isRequired,
  ).isRequired,
  limits: PropTypes.shape({
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    drop: PropTypes.number.isRequired,
  }).isRequired,
  onPosChange: PropTypes.func.isRequired,
  onActivate: PropTypes.func.isRequired,
};

export default ColorStopsHolder;



// WEBPACK FOOTER //
// ./src/components/GradientBuilder/ColorStopsHolder.js